import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {getCityLink} from "../utils/get_city_link";
import {trackPricesHubButtonClick} from "./track_prices_hub_button_click";

interface ITrackPricesHubPopularLocationClickParams {
    name: string;
    slug: string;
}

/** A link from the popular locations block leaves the page, so the event has to survive the navigation. */
export const trackPricesHubPopularLocationClick = (params: ITrackPricesHubPopularLocationClickParams) => {
    scheduleTrackingTask(() =>
        trackPricesHubButtonClick({
            buttonName: "rp_apartment_prices_popular_location",
            value: params.name,
            buttonLink: getCityLink(params.slug)
        })
    );
};
import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {getCityLink} from "../utils/get_city_link";
import {trackPricesHubButtonClick} from "./track_prices_hub_button_click";

interface ITrackPricesHubPopularLocationClickParams {
    name: string;
    slug: string;
}

/** A link from the popular locations block leaves the page, so the event has to survive the navigation. */
export const trackPricesHubPopularLocationClick = (params: ITrackPricesHubPopularLocationClickParams) => {
    scheduleTrackingTask(() =>
        trackPricesHubButtonClick({
            buttonName: "rp_apartment_prices_popular_location",
            value: params.name,
            buttonLink: getCityLink(params.slug)
        })
    );
};
